$(document).ready(function () {
    //-- Глобальные переменные
    var nHelper = $(".helper"),
        WIN = $(window),
        DOC = $(document),
        HTML = $('html'),
        BODY = $('body'),
        scrollTo = null;
    //-- End Глобальные переменные

    //-- Preloader
    function checkPreloader(){
        $('.preloader__wrapper').fadeOut('slow', function(){
            $(this).remove();
        });
    }
    checkPreloader();
    setTimeout(function(){
        checkPreloader();
    }, 1000);
    //-- End Preloader

    //-- Главный слайдер на главной
    var mainSlider = new Swiper ('[data-slider-main]', {
        loop: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        effect: 'fade',
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        preloadImages: true,
        lazy: {
          loadPrevNext: true
        }
    });

    //-- End Главный слайдер на главной

    //-- Слайдер победителей на главной
    var winnersSlider = new Swiper('[data-slider-winners]', {
        direction: 'vertical',
        loop: true,
        slidesPerView: 3,
        slidesPerGroup: 1,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        }
    });
    //-- End Слайдер победителей на главной

    //-- Слайдер победителей на турнирах
    var tournamentsSlider = new Swiper('[data-slider-prize]', {
        // loop: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next.tournaments-nav",
            prevEl: ".swiper-button-prev.tournaments-nav",
        },
        breakpoints: {
            640: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    });
    //-- End Слайдер победителей на главной

    // //-- Fix on scroll
    // var header = $(".header--bottom");
    // var headerHeight = 95;
    // var mainContent = $(".main");
    // $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= headerHeight && $(this).width() < 640) {
    //         header.addClass("mobile-bar-fixed-top");
    //         mainContent.addClass("mobile-main");
    //     } else {
    //         header.removeClass('mobile-bar-fixed-top');
    //         mainContent.removeClass("mobile-main");
    //     }
    // });
    // //-- end Fix on scroll



    // обрезка превью новости (добавить инициализацию по дата атрибуту)
    var newsTitle = $('.news__title a');
    var newsContent= $('.slider-news__description, .news__description');
    var bonusContent= $('.bonuses__description--text');
    var bonusTitle= $('.bonuses__description--subtitle');
    newsTitle.each(function(){
        var size = 60,
            newsText = $(this).text();

        if(newsText.length > size){
            $(this).text(newsText.slice(0, size) + ' ...');
        }
    });
    bonusTitle.each(function(){
        var size = 64,
            bonusesHeader = $(this).text();

        if(bonusesHeader.length > size){
            $(this).text(bonusesHeader.slice(0, size) + ' ...');
        }
    });

    newsContent.each(function(){
        var size = 220,
            newsText = $(this).text();

        if(newsText.length > size){
            $(this).text(newsText.slice(0, size) + ' ...');
        }
    });
    bonusContent.each(function(){
        var size = 80,
            bonusesText = $(this).text();

        if(bonusesText.length > size){
            $(this).text(bonusesText.slice(0, size) + ' ...');
        }
    });
    //-- End обрезка превью новости

    //-- Выбор даты рождения с ограничением по возрасту, дока по плагину http://t1m0n.name/air-datepicker/docs/

    //-- Инициализация поля выбора даты рождения
    function dateinit() {
        if ($('[data-datepicker]').length > 0 && $('[data-datepicker]').is(':visible')) {
            var input = document.querySelector("[data-datepicker]");
            if (!$('.datepickers-container').length) {
                var date = (new Date()).getFullYear();
                var maxdate = new Date();
                maxdate.setYear(date - 18);

                $('[data-datepicker]').datepicker({
                    maxDate: maxdate,
                    autoClose: true,
                    language: $('html').attr('lang')
                });
            }
        }
    }

    dateinit();

    $(document).on('ajaxSuccess', function () {
        dateinit();
    });
    //-- End Выбор даты рождения с ограничением по возрасту

    // enable spacing for credit card number
    function cardNumber() {
        $('.modal__cards-head .form__input input, .modal__cards-number input').on('keyup', function(e){
            var val = $(this).val();
            var newval = '';
            val = val.replace(/\s/g, '');

            // iterate to letter-spacing after every 4 digits
            for(var i = 0; i < val.length; i++) {
                if(i%4 == 0 && i > 0) newval = newval.concat(' ');
                newval = newval.concat(val[i]);
            }

            // format in same input field
            $(this).val(newval);
        });
    }

    cardNumber();
    // end enable spacing for credit card number

    //-- Регистрация поля секретный вопрос и секретный ответ

        if (!$('.secret_question').val()) {
            $('.secret_answer').hide();
        }
        $('.secret_question').on('change', function(){
            if ($(this).val()) {
                $('.secret_answer').show();
            } else {
                $('.secret_answer').hide();
            }
        });

    //-- End Регистрация поля секретный вопрос и секретный ответ

    //-- Рейтинг игры на странице Demo game
    var rating = $('[data-rating]');
    var isLogged = rating.data('logged') ? true : false;


    rating.rating({
        fx: 'half',
        image: '/front/img/stars.png',
        loader: '/front/img/ajax-loader.gif',
        readOnly: isLogged
    });
    if(isLogged){
        $('.vote-hover').css({
            'cursor':'default'
        });
    }
    //-- End Рейтинг игры на странице Demo game

    //-- Описание бонуса с flip-эффектом

    $('[data-bonus-fliper]').click(function(){
        var bonus = $(this).parents('[data-bonus-flip]');
        bonus.toggleClass('flip');
    });
    //-- End

    //-- Mobile tables
    (function () {
        var headertext = [];
        var headers = document.querySelectorAll("thead");
        var tablebody = document.querySelectorAll("tbody");

        for (var i = 0; i < headers.length; i++) {
            headertext[i] = [];
            for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
                var current = headrow;
                headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
            }
        }
        if (headers.length > 0) {
            for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                for (var i = 0, row; row = tbody.rows[i]; i++) {
                    for (var j = 0, col; col = row.cells[j]; j++) {
                        col.setAttribute("data-label", headertext[h][j]);
                    }
                }
            }
        }
    }());
    //-- End Mobile tables

    //-- List to Grid view for tables
    function viewSwitcher(e) {
        const listButton = $('[data-view-table]');
        const gridButton = $('[data-view-grid]');
        const wrapper = $('.table');
        listButton.on('click', function() {
            gridButton.removeClass('active');
            listButton.addClass('active');
            wrapper.removeClass('table-grid').addClass('table-list');
            $.cookie('TableView', 'table-view', {path: '/' });
        });
        gridButton.addClass('active');
        gridButton.on('click', function() {
            listButton.removeClass('active');
            gridButton.addClass('active');
            wrapper.removeClass('table-list').addClass('table-grid');
            $.cookie('TableView', 'grid-view', {path: '/' });
        });

        setTimeout(function() {
            if (WIN.width() <= 768) {
                wrapper.removeClass('table-list').addClass('table-grid');
            }
        }, 200);
        WIN.on('resize', function() {
            if (WIN.width() <= 768) {
                wrapper.removeClass('table-list').addClass('table-grid')
            }
            if (WIN.width() > 768 && $("[data-view-table]").hasClass('active')) {
                wrapper.removeClass('table-grid').addClass('table-list')
            }
            if (WIN.width() > 768) {
                $('.profile__accounts').removeClass('table-grid').addClass('table-list');
                $('.profile__payments').removeClass('table-grid').addClass('table-list')
            }
        });
    }
    viewSwitcher();

    //-- End List to Grid view for tables

    // ADD cookies List to Grid view for tables
    function setTableView() {
        if ( $.cookie('TableView') == null ) {
            $.cookie('TableView', 'grid-view', {path: '/' });
        }
        if ( $.cookie('TableView') == 'grid-view' ) {
            $('[data-view-grid]').click();
        }

        if ( $.cookie('TableView') == 'table-view' ){
            $('[data-view-table]').click();
        }
    }
    setTableView();


    // END ADD cookies List to Grid view for tables



    //-- Toggler для описания бонусов
    $("[data-bonus-toggler]").click(function(){
        $(this).toggleClass("opened").next(".bonuses__description").slideToggle();
    });
    //-- End Toggler для описания бонусов

    //-- Реализация адаптивности iframe в статьях
    $('.article__content iframe').each(function (){
        $(this).wrap('<div class="videowrapper">');
    });
    //-- end

    //-- Мобильное меню и поиск

    function mobileMenu() {
        let buttons = $('[data-mobile-menu]');
        let wrapper = $('.mobile-wrapper');
        buttons.on('click', function(e){
            e.preventDefault();
            let that = $(e.target);
            if(!that.hasClass('close')) {
                buttons.removeClass('close');
                that.addClass('close');
                that.addClass('icon-close');
                that.removeClass('icon-menu');
                wrapper.addClass('opened');
                BODY.addClass('fixed');
            } else {
                that.removeClass('close');
                that.removeClass('icon-close');
                that.addClass('icon-menu');
                wrapper.removeClass('opened');
                BODY.removeClass('fixed');
            }
        })
    }
    mobileMenu();

    WIN.on('resize', function() {

        if ($('[data-mobile-menu]').hasClass('close') && WIN.width() >= 980) {
            $('[data-mobile-menu]').click();
        }

        // $('[data-mobile-menu].close').each(function() {
        //     $('[data-mobile-menu].close').removeClass('close');
        // });
        // $('.mobile-wrapper.opened').each(function() {
        //     $('.mobile-wrapper.opened').removeClass('opened');
        // });
    });
    //-- End мобильного меню и поиск//

    //-- special checkboxes border when checked

    function bonusSelected(){
        var radios = $('.special-radio__hidden-input');

        radios.filter(':checked').parents('.special-radio').addClass('checked');

        radios.change(function () {
            radios.parents('.special-radio').removeClass('checked');
            $(this).parents('.special-radio').addClass('checked');
        });
    }

    bonusSelected();

    setTimeout(function () {
        bonusSelected();
    }, 1000);



    //-- END special checkboxes border when checked

    //-- User menu
    $(".user__avatar").click(function(){
        $(this).toggleClass('active');
        $('.user-menu__wrapper').toggleClass('opened');
    });
    DOC.on('click', function(e){
        if (!$(e.target).closest(".user__avatar").length) {
            $('.user-menu__wrapper').removeClass('opened');
        }
        e.stopPropagation();
    });

    //-- End user menu

	//-- Set fiat currency menu

	$("[data-accounts-menu]").click(function(){
		$(this).toggleClass('active');
		$('[data-accounts-menu] ul').toggleClass('opened');
	});

	//-- End set fiat currency menu


    DOC.on('click', ".deposit__amount li", function () {
        var amount = $(this).html();
        $(".deposit__amount li").removeClass('active');
        $(this).addClass('active');
        $('[data-deposit-amount]').val(amount).focus();
    });


    //-- Реализация мобильного меню-аккардеон

    var trigger = $('.menu__link');

    trigger.on('click', function(){
        // e.preventDefault();
        var $this = $(this),
            item = $this.closest('.mobile-menu__item'),
            list = $this.closest('.mobile-menu'),
            items = list.find('.mobile-menu__item'),
            content = item.find('.submenu'),
            otherContent = list.find('.submenu'),
            duration = 250,
            active = 'active';
        if(!item.hasClass(active)) {
            items.removeClass(active);
            item.addClass(active);
            otherContent.stop(true,true).slideUp(duration);
            content.stop(true,true).slideDown(duration);
        } else {
            content.stop(true,true).slideUp(duration);
            item.removeClass(active);
        }
    });

    $("a.menu__link[href*='/']").addClass("link");
    //-- End Реализация мобильного меню-аккардеон

	//-- scrollbar width
	function getScrollbarWidth() {
		return window.innerWidth - document.documentElement.clientWidth;
	}


    //-- Инициализация модалок
    $(document).on('ajaxSuccess', function () {
        $('[data-modal-ajax]').magnificPopup({
            type: 'ajax',
            removalDelay: 300,
            mainClass: 'mfp-zoom-in',
            callbacks: {
                parseAjax: function(mfpResponse) {
                    mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function() {
                    this.content;
                },
	            beforeOpen: function() {
		            const scrollbarWidth = getScrollbarWidth();
		            $('body').addClass('blur');
		            $(".desktop .helper__bg").css({ right: scrollbarWidth + "px" });
	            },
	            beforeClose: function() {
		            $('body').removeClass('blur');
	            },
	            close: function () {
		            $(".desktop .helper__bg").css({ right: 0 });
	            }
            }
        });
    });

    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            beforeOpen: function() {
	            const scrollbarWidth = getScrollbarWidth();
                $('body').addClass('blur');
	            $(".desktop .helper__bg").css({ right: scrollbarWidth + "px" });
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            },
	        close: function () {
		        $(".desktop .helper__bg").css({ right: 0 });
	        }
        }
    });

    $('[data-modal-loader]').magnificPopup({
        type: 'ajax',
        preloader: false,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping wrapping--loader'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
	        beforeOpen: function() {
		        const scrollbarWidth = getScrollbarWidth();
		        $('body').addClass('blur');
		        $(".desktop .helper__bg").css({ right: scrollbarWidth + "px" });
	        },
	        beforeClose: function() {
		        $('body').removeClass('blur');
	        },
	        close: function () {
		        $(".desktop .helper__bg").css({ right: 0 });
	        }
        }
    });
    //-- End Инициализация модалок

    // $(document).on('ajaxSuccess', function () {
    //
    //     $('select').each(function () {
    //         if (!$(this).parent().hasClass('selectricHideSelect')) {
    //             if ( $("select").length > 0 ){
    //                 $(this).selectric({
    //                     maxHeight: 200,
    //                     disableOnMobile: false,
    //                     nativeOnMobile: false,
    //                     onInit: function() {
    //                         if ($(this).find('option').length === 1) {
    //                             $(this).parents('.selectric-wrapper').addClass('selectric--void');
    //                         }
    //                     }
    //                 });
    //             }
    //         }
    //     });
    // });

    /**
     * Инициализация select menu
     * Используется в формах, которые подгружаются на ajax
     * Для этого вынесен в функцию для использования внутри ajaxSuccess
     **/
    function selectInit(){
        $('[data-select-menu]').each(function () {
            if (!$(this).parent().hasClass('selectric-hide-select')) {
                $(this).selectric({
                    maxHeight: 200,
                    disableOnMobile: false,
                    nativeOnMobile: false,
                    onInit: function() {

                        // проверка на количество эллементов, если 1 - то добавляем класс,
                        // который скрывает всю навигацию
                        if($(this).find('option').length === 1){
                            $(this).parents('.selectric-wrapper').addClass('selectric--void');
                        }
                    }
                });
            }
        });
    }

    selectInit();


    $('[data-select-tournaments]').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
    }).off('change').on('change', function () {
        let place = '[' + $(this).attr('data-place') + ']';
        $(place).html($(this).val());
    });



    /** Инициализация select2 **/
    function selectSearch() {
        $('[data-select-search]').each(function() {
            if (!$(this).hasClass('select2-hidden-accessible')) {
                $(this).select2({
                    dropdownParent: $('.mfp-content .wrapping')
                });
            }
        });
    }
    selectSearch();
    /** End **/



    /**
     * Инициализация модального окна, inline type
     */

    $('[data-modal-inline]').magnificPopup({
        type:'inline',
        midClick: true
    });




    /**
     * Инициализация модального окна, которое невозможно закрыть
     */
    $('[data-modal--immortal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        closeOnBgClick: false,
        showCloseBtn: false,
        enableEscapeKey: false,
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
	        beforeOpen: function() {
		        const scrollbarWidth = getScrollbarWidth();
		        $('body').addClass('blur');
		        $(".desktop .helper__bg").css({ right: scrollbarWidth + "px" });
	        },
	        beforeClose: function() {
		        $('body').removeClass('blur');
	        },
	        close: function () {
		        $(".desktop .helper__bg").css({ right: 0 });
	        }
        }
    });

    //-- Инициализация select menu валют
    $('[data-select-currency]').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onInit: function() {
            if($(this).find('option').length === 1){
                $(this).parents('.selectric-wrapper').addClass('selectric--void');
            }
        }
    }).on('change', function() {
        location.href = $(this).val();
    });
    //-- End Инициализация select menu валют

    //-- Fix для пагинации таблиц в кабинете игрока (решение под вопросом, костыль из-за бэкендеров)
    DOC.on('click', '.pager__item a', function(event) {
        $('html, body').animate({
            scrollTop: $('#table-top').offset().top
        }, 500);
    });
    //-- End Fix для пагинации таблиц в кабинете игрока

    //-- Fix Hover on mobile
    fixHover('.games__item', '.games__item__overlay', 'games__item__overlay--active');
    function fixHover(sSelestor, sHover, sActiveClass) {
        $(sSelestor).hover(
            function() {
                $(this)
                    .find(sHover)
                    .addClass(sActiveClass);
            },
            function() {
                $(this)
                    .find(sHover)
                    .removeClass(sActiveClass);
            }
        );
    }
    //-- End Fix Hover on mobile


    // registration tabs

    $('ul.registration__tabs--top').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active');
        $('.registration__tabs--content').removeClass('active');

        var reg_email = $(this).attr('data-email-tab'),
            reg_tel = $(this).attr('data-phone-tab');

        if (typeof reg_email !== typeof undefined && reg_email !== false) {
            $('[data-register-email]').addClass('active');
            $.cookie('RegView', 'email-first', {path: '/' });

        }
        if (typeof reg_tel !== typeof undefined && reg_tel !== false) {
            $('[data-register-phone]').addClass('active');
            $.cookie('RegView', 'phone-first', {path: '/' });
        }
        phoneinit();
    });


    //-- Инициализация поля выбора телефона
    function phoneinit() {
        if ($('[data-profile-phone]').length > 0 && $('[data-profile-phone]').is(':visible')) {
            var input = document.querySelector("[data-profile-phone]");
            if (!$('.iti').length) {
                var iti = window.intlTelInput(input, {
                    initialCountry: "ua",
                    autoHideDialCode: true,
                    nationalMode: false,
                    separateDialCode: true,
                    // hiddenInput: "full_phone",
                    numberType: "MOBILE",
                    preferredCountries: ["ru", "ua", "by", "kz"],
                    // geoIpLookup: function(callback) {
                    //     $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                    //         var countryCode = (resp && resp.country) ? resp.country : "";
                    //         callback(countryCode);
                    //     });
                    // },
                    utilsScript: "/front/js/utils.js" // just for formatting/placeholders etc
                });
            }
        }
    }

    phoneinit();
    // //-- Инициализация поля выбора телефона в табах регистрации
    // DOC.on('ajaxSuccess', function (data) {
    //     $('ul.registration__tabs--top').on('click', 'li:not(.active)', function () {
    //         $(this).addClass('active').siblings().removeClass('active');
    //         $('.registration__tabs--content').removeClass('active');
    //
    //         var reg_email = $(this).attr('data-email-tab'),
    //             reg_tel = $(this).attr('data-phone-tab');
    //
    //         if (typeof reg_email !== typeof undefined && reg_email !== false) {
    //             $('[data-register-email]').addClass('active');
    //
    //         }
    //         if (typeof reg_tel !== typeof undefined && reg_tel !== false) {
    //             $('[data-register-phone]').addClass('active');
    //
    //         }
    //         phoneinit();
    //     });
    //
    //     /* registration phone */
    //
    //     if ($('[data-phone-tab]').hasClass('active')) {
    //         phoneinit();
    //     }
    //
    //     if (!$('.registration__tabs--content').length) {
    //         phoneinit();
    //     }
    //
    //     function phoneinit() {
    //         if ($('[data-reg-phone]').length) {
    //             if (!$('.registration__tabs--content .iti').length) {
    //                 var input = document.querySelector("[data-reg-phone]");
    //                 var iti = window.intlTelInput(input, {
    //                     initialCountry: "auto",
    //                     autoHideDialCode: true,
    //                     nationalMode: false,
    //                     separateDialCode: true,
    //                     hiddenInput: "full_phone",
    //                     numberType: "MOBILE",
    //                     preferredCountries: ["ru", "ua", "by", "kz"],
    //                     geoIpLookup: function (callback) {
    //                         $.get('https://ipinfo.io', function () {
    //                         }, "jsonp").always(function (resp) {
    //                             var countryCode = (resp && resp.country) ? resp.country : "";
    //                             callback(countryCode);
    //                         });
    //                     },
    //                     utilsScript: "/front/js/utils.js" // just for formatting/placeholders etc
    //                 });
    //             }
    //         }
    //     }
    // });
    //
    // //-- End Инициализация поля выбора телефона в табах регистрации


    // ADD cookies registration tabs
    function setRegView() {
        if ( $.cookie('RegView') == null ) {
            $.cookie('RegView', 'email-first', {path: '/' });
        }
        if ( $.cookie('RegView') == 'email-first' ) {
            $('[data-email-tab]').click();
        }
        if ( $.cookie('RegView') == 'phone-first' ){
            $('[data-phone-tab]').click();
            phoneinit();
        }
    }
    setRegView();
    // END ADD cookies registration tabs


    /** Tabs + cookies / tournaments **/
    function tournamentsSwitcher(e) {
        const tournamentsAll = $('[data-tournament-all]');
        const tournamentsAllItem = $('[data-tournament-all-item]');

        const tournamentsComing = $('[data-tournament-coming]');
        const tournamentsComingItem = $('[data-tournament-coming-item]');

        const tournamentsActive = $('[data-tournament-active]');
        const tournamentsActiveItem = $('[data-tournament-active-item]');

        const tournamentsSubscribed = $('[data-tournament-subscribed]');
        const tournamentsSubscribedItem = $('[data-tournament-subscribed-item]');

        const tournamentsCanceled = $('[data-tournament-canceled]');
        const tournamentsCanceledItem = $('[data-tournament-canceled-item]');

        const tournamentsFinished = $('[data-tournament-finished]');
        const tournamentsFinishedItem = $('[data-tournament-finished-item]');

        const tournamentsAvailable = $('[data-tournament-available]');
        const tournamentsAvailableItem = $('[data-tournament-available-item]');

        const tournamentsUnsubscribed = $('[data-tournament-unsubscribed]');
        const tournamentsUnsubscribedItem = $('[data-tournament-unsubscribed-item]');

        tournamentsAll.on('click', function () {
            tournamentsAllItem.addClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-all', {path: '/'});
        });
        tournamentsComing.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.addClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-coming', {path: '/'});
        });
        tournamentsActive.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.addClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');;
            $.cookie('tournamentSwitcher', 'tournaments-active', {path: '/'});
        });
        tournamentsSubscribed.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.addClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-subscribed', {path: '/'});
        });
        tournamentsCanceled.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.addClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-canceled', {path: '/'});
        });
        tournamentsFinished.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.addClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-finished', {path: '/'});
        });

        tournamentsAvailable.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.addClass('active');
            tournamentsUnsubscribedItem.removeClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-available', {path: '/'});
        });
        tournamentsUnsubscribed.on('click', function () {
            tournamentsAllItem.removeClass('active');
            tournamentsSubscribedItem.removeClass('active');
            tournamentsCanceledItem.removeClass('active');
            tournamentsFinishedItem.removeClass('active');
            tournamentsActiveItem.removeClass('active');
            tournamentsComingItem.removeClass('active');
            tournamentsAvailableItem.removeClass('active');
            tournamentsUnsubscribedItem.addClass('active');
            $.cookie('tournamentSwitcher', 'tournaments-unsubscribed', {path: '/'});
        });
    }
    tournamentsSwitcher();

    $('ul.tournament__tabs--top').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active').closest('.page--tournament').find('.tournament__item').removeClass('active').eq($(this).index()).addClass('active');
    });

    function setTournamentsView() {
        if ( $.cookie('tournamentSwitcher') == null ) {
            $.cookie('tournamentSwitcher', 'tournaments-all', {path: '/'});
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-all' ) {
            $('[data-tournament-all]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-coming' ) {
            $('[data-tournament-coming]').click();
            //console.log('comins');
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-active' ) {
            $('[data-tournament-active]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-subscribed' ) {
            $('[data-tournament-subscribed]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-canceled' ) {
            $('[data-tournament-canceled]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-finished' ) {
            $('[data-tournament-finished]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-available' ) {
            $('[data-tournament-available]').click();
        }
        if ( $.cookie('tournamentSwitcher') == 'tournaments-unsubscribed' ) {
            $('[data-tournament-unsubscribed]').click();
        }

        //console.log($.cookie('tournamentSwitcher'))
    }

    setTournamentsView();

    //-- End Tabs tournaments


    //-- Avatar load в профиле Игрока
    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                $('.profile-pic').attr('src', e.target.result);
            };
            reader.readAsDataURL(input.files[0]);
        }
    };
    $('#avatar-form').submit(function(){
        readURL($('#avatar-input'));
    });
    //-- End Avatar load в профиле Игрока

    //-- Document load в кабинете Игрока
    $(".upload-button").on('click', function() {
        $(".file-upload").click();
    });
    //-- End Document load в кабинете Игрока

    //-- Tabs история транзакций
    function historySwitcher(e) {
        const historyDeposit = $('[data-history-deposit]');
        const historywithdraw = $('[data-history-withdraw]');
        historywithdraw.on('click', function () {
            historyDeposit.removeClass('active');
            historywithdraw.addClass('active');
            $.cookie('HistorySwitcher', 'history-withdraw', {path: '/'});
        });
        historyDeposit.on('click', function () {
            historywithdraw.removeClass('active');
            historyDeposit.addClass('active');
            $.cookie('HistorySwitcher', 'history-deposit', {path: '/'});
        });
    }
    historySwitcher();
    //-- End Tabs история транзакций

    // ADD cookies history transaction switcher
    function setHistoryView() {
        if ( $.cookie('HistorySwitcher') == null ) {
            $.cookie('HistorySwitcher', 'history-withdraw', {path: '/'});
        }
        if ( $.cookie('HistorySwitcher') == 'history-withdraw' ) {
            $('[data-history-withdraw]').click();
        }

        if ( $.cookie('HistorySwitcher') == 'history-deposit' ){
            $('[data-history-deposit]').click();
        }
    }
    setHistoryView();
    // END ADD cookies history transaction switcher

    //-- Tabs profile bonuses
    function bonusesSwitcher(e) {
        const bonusesActive = $('[data-bonuses-active]');
        const bonusesAvailable = $('[data-bonuses-available]');
        bonusesAvailable.on('click', function () {
            bonusesActive.removeClass('active');
            bonusesAvailable.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-available', {path: '/'});
        });
        bonusesActive.on('click', function () {
            bonusesAvailable.removeClass('active');
            bonusesActive.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-active', {path: '/'});
        });
    }
    bonusesSwitcher();
    //-- End Tabs profile bonuses

    // ADD cookies profile bonuses switcher
    function setBonusesView() {
        if ( $.cookie('BonusesSwitcher') == null ) {
            $.cookie('BonusesSwitcher', 'bonuses-available', {path: '/'});
        }
        if ( $.cookie('BonusesSwitcher') == 'bonuses-available' ) {
            $('[data-bonuses-available]').click();
        }

        if ( $.cookie('BonusesSwitcher') == 'bonuses-active' ){
            $('[data-bonuses-active]').click();
        }
    }
    setBonusesView();
    // END ADD cookies profile bonuses switcher




    //-- Tabs profile
    $('ul.profile__tabs--top').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active').closest('.page-profile').find('div.profile__section').removeClass('active').eq($(this).index()).addClass('active');
        if ($('.profile__section').hasClass('active')) {
            phoneinit();
        }
    });
    //-- End Tabs profile

    //-- замена ломаной картинки дефолтной картинкой
    $('.tables__item__img img').each(function(){
        var valid_extensions = /(\.jpg|\.jpeg|\.png)$/i;

        if(valid_extensions.test($(this).attr('src')))
        {
            $(this).on( "error", function(){
                $(this).attr('src', '../../img/logos/logo.png');
            });
        }
        else{
            $(this).attr('src', '../../img/logos/logo.png');
        }
    });

    $('.documents-list__img img').each(function(){
        var valid_extensions = /(\.jpg|\.jpeg|\.png)$/i;

        if(valid_extensions.test($(this).attr('src')))
        {
            $(this).on( "error", function(){
                $(this).attr('src', '../../img/documents/docs-loaded.svg');
            });
        }
        else{
            $(this).attr('src', '../../img/documents/docs-loaded.svg');
        }
    });

    $('.news__img img').each(function(){
        var valid_extensions = /(\.jpg|\.jpeg|\.png)$/i;

        if(valid_extensions.test($(this).attr('src')))
        {
            $(this).on( "error", function(){
                $(this).attr('src', '/front/img/news/default.png');
            });
        }
        else{
            $(this).attr('src', '/front/img/news/default.png');
        }
    });

    $('.transactions__img img').each(function(){
        var valid_extensions = /(\.jpg|\.jpeg|\.png)$/i;

        if(valid_extensions.test($(this).attr('src')))
        {
            $(this).on( "error", function(){
                $(this).attr('src', '/front/img/payments/payments-default.png');
            });
        }
        else{
            $(this).attr('src', '/front/img/payments/payments-default.png');
        }
    });
    //-- END замена ломаной картинки дефолтной картинкой

    //-- Lang Select menu
    $('.lang-select').click(function(){
        $(this).toggleClass('open');
    });
    $('.lang-select li').click(function(){
        $('ul li').removeClass('active');
        $(this).toggleClass('active');
    });
    //-- End Lang Select menu


    //-- demo game info scroll
    $('[data-game-info-button]').on("click", function () {
        $('html, body').animate({
            scrollTop: $("div.game__info__more").offset().top
        }, 1000)
    });

    $('#scroll').click(function(){
        var gameInfo = $('[data-game-info]');
        var footer = $("footer");
        $("html, body").animate({ scrollTop: 0 }, 500);
        gameInfo.slideToggle(600);
        footer.slideToggle(600);
        return false;
    });
    //--  END demo game info scroll

    //-- Определяем ширину скроллбара в текущем браузере
    var div = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';

    document.body.appendChild(div);
    var scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    //-- End Определяем ширину скроллбара в текущем браузере

    /**
     * Событие клика на элементе faq. Показывает\скрывает ответ на вопрос + сообщения
     */
    DOC.on('click', '[data-faq-question]', function(){
        var item = $(this).parents('.faq__item');
        var answer = $('[data-faq-answer]');
        item.find(answer).slideToggle();
        item.toggleClass('faq--open');
    });

    DOC.on('click', '[data-msg-title]', function(){
        var item = $(this).parents('.msg__list li');
        var answer = $('[data-msg-content]');
        item.find(answer).slideToggle();
        item.toggleClass('msg--open');
    });
    /**
     * Иниализация отложенной подгрузки изображений
     */
    function lazyLoad(){
        $('[data-lazy] img[data-src]').Lazy({
            scrollDirection: 'vertical',
            effect: 'fadeIn',
            delay: 0,
            effectTime: 500,
            threshold: 0,
            visibleOnly: true,
            onError: function(element) {
                // console.log('error loading ' + element.data('src'));
                element.attr("src","../img/logos/logo.png").addClass('no-photo');
            }
        });
    }

    lazyLoad();
    /**
     * Lazy load for background img
     */
    $(function() {
        $('.helper').lazy(
            {
                effect: "fadeIn"
            });
    });
    $(function() {
        $('.helper-game').lazy(
            {
                effect: "fadeIn"
            });
    });
    /**
     * Событие смены видимости пароля в инпуте
     */
    var passwordToggler = ('[data-password-toggler]');

    DOC.on('click', passwordToggler, function() {
        var btn = $(this),
            input = btn.siblings('input');

        btn.toggleClass('icon-view');
        btn.toggleClass('icon-hide');
        if(input.attr('type') == 'text'){
            input.attr('type', 'password');
        }
        else{
            input.attr('type', 'text');
        }
    });
    /**
     * Стилизация скроллабара в блоках
     */
    $('[data-scrollbar]').scrollbar({
        "showArrows": true,
        "scrolly": 'advanced',
        "ignoreOverlay": true
    });

    $('.scroll-wrapper').each(function(){
        setTimeout(function () {
            if($(this).height() < $(this).parent().height()){
                $(this).addClass('scroll--void').find('.scroll-element').hide();
            }
        }, 100);
    });

    /**
     * Закрытие списка языков при клике вне его
     */
    DOC.on('click', function(e){
        if (!$(e.target).closest(".lang").length) {
            $('.lang-select').removeClass('open');
        }
        e.stopPropagation();
    });

    /**
     * Слайдер победителей в шапке демо игры
     */
    var slide = $('.slide'),
        slideUl = slide.find('.winner__list'),
        slideUlLi = slideUl.find('.winner'),
        slideTime = 3000;

    function runSlide() {
        if (slideUlLi.hasClass('slide-active')) {
            $('.slide-active').slideDown().siblings().slideUp();
        }
    }

    function startSlide() {
        slideUlLi.first().addClass('slide-active').siblings().removeClass('slide-active');
        runSlide();
    }
    startSlide();

    function autoSlide() {
        if ($('.slide-active').is(':last-of-type')) {
            setTimeout(startSlide, 100);
        } else {
            $('.slide-active').next().addClass('slide-active').siblings().removeClass('slide-active');
            runSlide();
        }
    }
    slideUlLi.each(function() {
        runSlide();
    });
    setInterval(autoSlide, slideTime);

    /**
     * Инициализация плагина обратного отсчета
     */
    $('[data-time]').each(function(){
        $(this).countdown($(this).attr('data-time'), function(event) {
            $(this).html(event.strftime('' +
                '<span>' +
                '<span>%D</span>' +
                $(this).attr('data-days') +
                '</span>' +
                '<span>' +
                '<span class="counter--separator">:</span>' +
                '</span>' +
                '<span>' +
                '<span>%H</span>' +
                $(this).attr('data-hours') +
                '</span>' +
                '<span>' +
                '<span class="counter--separator">:</span>' +
                '</span>' +
                '<span>' +
                '<span>%M</span>' +
                $(this).attr('data-min') +
                '</span>' +
                '<span>' +
                '<span class="counter--separator yt__reverse">:</span>' +
                '</span>' +
                '<span>' +
                '<span class="yt__reverse">%S</span>' +
                $(this).attr('data-sec') +
                '</span>'
            ));
        });
    });

    $('[data-time-bonus]').each(function(){
        $(this).countdown($(this).attr('data-time-bonus'), function(event) {
            $(this).html(event.strftime('<span>%D</span> ' +
                $(this).attr('data-days') + ' ' +
                '<span class="counter--separator">:</span>' +
                '<span>%H</span>' +
                $(this).attr('data-hours') + ' ' +
                '<span class="counter--separator">:</span>' +
                ' <span>%M</span>' +
                $(this).attr('data-min') +
                '<span class="counter--separator">:</span>' +
                '<span>%S</span>' +
                $(this).attr('data-sec') 
            ));
        });
    });


    //
    $("[data-avatar-submit]").on('click', function() {
        $("[data-avatar-upload]").click();
    });



    // Game tabs
    $('[data-game-tabs]').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active').closest('div.game__box--right')
            .find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
        if ($('[data-tabs-tournament]').hasClass('active')) {
            $('[data-topinfo]').addClass('open');
        }
        else {
            $('[data-topinfo]').removeClass('open');
        }
    });

    //-- Tabs giveaway
    $('[data-giveaway]').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active').parents('.tabs__caption').siblings('.tabs__wrapper')
        .find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');

    });
    //-- End Tabs profile bonuses

    //-- cookies
    setTimeout(function () {
        $('[data-cookie-messege]').addClass("show")
    }, 2000);

    var date = new Date();
    var days = 365;
    date.setTime(date.getTime() + days * (24 * 60 * 60 * 1000));

    $('[data-cookie-accept]').click(function(){
        $.cookie('cookies-accepted', 'yes', { expires: date, path: '/' });
        if ( $.cookie('cookies-accepted') === 'yes' ) {
            $('[data-cookie-messege]').fadeOut(300, function() {
                $(this).remove();
            });
        }
    });

    if ( $.cookie('cookies-accepted') === 'yes' ) {
        $('[data-cookie-messege]').remove();
    }
    //-- End cookies

    /**
     * Определяем браузеры Internet Explorer 11 и Edge
     */
    let ua = window.navigator.userAgent,
        edge_ua = ua.indexOf('Edge/'),
        ie_ua = ua.indexOf('Trident/7.0'),
        edge = 'edge',
        ie = 'ie';
    if(edge_ua > 0) {
        HTML.addClass(edge);
    }
    if(ie_ua + 1){
        HTML.addClass(ie);
    }



    if($('html').hasClass('ie')){
        $('.ieOff').show();
        $('.helper').remove();
    }
    else{
        $('.ieOff').remove();
    }


    var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
        isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
    if (isMacLike) {
        $("html").addClass("apple");
    }
    if (isIOS) {
        $("html").addClass("ios");
    }

    /**
     * Событие срабатывает в случае успешного выполнения ajax запроса
     **/
    $(document).on('ajaxSuccess', function () {
        selectInit();
        bonusSelected();
        selectSearch();
        cardNumber();
    });

    /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
	var shortText= $('[data-cut-text]');
	shortText.each(function(){
		var size = $(this).data('cutText'),
			elementText = $(this).text();
		if(elementText.length > size){
			$(this).text(elementText.slice(0, size) + ' ...');
		}
	});


	/**
	 * Fix для контактов пользователя. Инициализация плагина телефона,
	 * если ещё не подгрузились поля.
	 */

	const phoneWrapperObserver = new MutationObserver((mutationsList) => {
		mutationsList.forEach((mutation) => {
			if (mutation.type === "childList" || mutation.type === "attributes") {
				const phoneWrapper = document.querySelector("#phone-wrapper");
				if (phoneWrapper && !phoneWrapper.classList.contains("phone-inited")) {
					phoneWrapper.classList.add("phone-inited");
					phoneinit();
				}
			}
		});
	});

	// Запускаем отслеживание изменений внутри body
	const phoneWrapper = document.querySelector("#phone-wrapper");
	if (phoneWrapper) {
		phoneWrapperObserver.observe(phoneWrapper, {
			childList: true,  // Отслеживание добавления/удаления элементов
			attributes: true, // Отслеживание изменений атрибутов
			subtree: true,    // Включает все дочерние элементы
		});
	}



});
